var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"radio"},[_c('input',{attrs:{"type":"radio","id":_vm.id,"name":_vm.nameField},domProps:{"value":_vm.modelValue,"checked":_vm.isActive}}),_vm._v(" "),_c('label',{staticClass:"radio-view",attrs:{"for":_vm.id}}),_vm._v(" "),_c('span',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }